import { client } from './client'

import type {
  CreateReportBody,
  CreateReportResponse,
  ListReportsParams,
  ListReportsResponse,
  Report,
  ReportDetails,
} from './types'

export const createReport = async (body: CreateReportBody): Promise<CreateReportResponse> => {
  const { data } = await client.post<CreateReportResponse>('/reports', body)

  return data
}

export const listReports = async (params: ListReportsParams): Promise<ListReportsResponse> => {
  const { data } = await client.get<ListReportsResponse>('/reports', { params })

  return data
}

export const getReportDetails = async (jobId: Report['jobId']): Promise<ReportDetails> => {
  const { data } = await client.get<ReportDetails>(`/reports/${jobId}`)

  return data
}
